import { onMounted, onBeforeUnmount } from 'vue'

export function useShortCut () {
  const shortCutEnum = {
    leaveParty: 'Shift+L',
    controlCamera: 'Shift+C',
    controlMic: 'Shift+M',
    controlSpeaker: 'Shift+S',
    controlShare: 'Shift+Control+S',
    controlChat: 'Shift+Ctrl+C'
  }

  const listeners = []

  const emit = (type, combo) => {
    listeners.forEach(fn => {
      try { fn({ type, combo }) } catch (e) {}
    })
  }

  const pressedKeys = new Set()
  const triggered = new Set()

  const isMac = typeof navigator !== 'undefined' && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform || '')

  const normalize = k => {
    if (!k) return ''
    if (k === 'Ctrl') return 'Control'
    if (k === 'Cmd' || k === 'Command') return 'Meta'
    if (k === 'Option') return 'Alt'
    if (k.length === 1) return k.toUpperCase()
    return k
  }

  const parseCombo = combo => combo.split('+').map(normalize)
  const combosMap = {}
  const ensureArray = v => Array.isArray(v) ? v : [v]
  Object.keys(shortCutEnum).forEach(type => {
    const base = ensureArray(shortCutEnum[type]).map(parseCombo)
    const expanded = []
    base.forEach(arr => {
      expanded.push(arr)
      if (arr.includes('Control') && isMac) {
        expanded.push(arr.map(x => x === 'Control' ? 'Meta' : x))
      }
      if (arr.includes('Meta') && !isMac) {
        expanded.push(arr.map(x => x === 'Meta' ? 'Control' : x))
      }
    })
    const uniq = []
    const seen = new Set()
    expanded.forEach(arr => {
      const key = arr.join('+')
      if (!seen.has(key)) {
        seen.add(key)
        uniq.push(arr)
      }
    })
    combosMap[type] = uniq
  })

  const keydown = e => {
    const key = normalize(e.key)
    pressedKeys.add(key)
    Object.keys(combosMap).forEach(type => {
      const variants = combosMap[type]
      const matched = variants.some(required => required.every(k => pressedKeys.has(k)) && pressedKeys.size === required.length)
      if (matched && !triggered.has(type)) {
        triggered.add(type)
        emit(type, Array.isArray(shortCutEnum[type]) ? shortCutEnum[type][0] : shortCutEnum[type])
        e.preventDefault()
      }
    })
  }

  const keyup = e => {
    const key = normalize(e.key)
    pressedKeys.delete(key)
    triggered.clear()
  }

  const blur = () => {
    pressedKeys.clear()
    triggered.clear()
  }

  onMounted(() => {
    window.addEventListener('keydown', keydown)
    window.addEventListener('keyup', keyup)
    window.addEventListener('blur', blur)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', keydown)
    window.removeEventListener('keyup', keyup)
    window.removeEventListener('blur', blur)
  })

  const onTrigger = fn => {
    if (fn && typeof fn === 'function') listeners.push(fn)
    return () => {
      const i = listeners.indexOf(fn)
      if (i > -1) listeners.splice(i, 1)
    }
  }

  return { shortCutEnum, onTrigger }
}
